<template>
    <div class="btn-group">
        <button class="btn btn-danger btn-xs" @click="deleteClicked()">
            Delete
        </button>

        <button class="btn btn-info btn-xs" @click="editClicked()">
            <i class="iconsminds-pen"></i>
            Edit
        </button>
    </div>
</template>

<script>
export default {
    name: 'table-actions',
    props: {
        data: Object
    },

    methods: {
        deleteClicked: function () {
            this.$emit('deleteClicked', this.data);
        },
        editClicked: function () {
            this.$emit('editClicked', this.data);
        }
    }
};
</script>
